import type { HubPartIdentification } from '../../services/hubApi';

/** What the shop step shows after a "Describe it" search: a part card with a heading, or a miss with a note. */
export interface DescribeOutcome {
  kind: 'match' | 'miss';
  heading: string | null;
  note: string | null;
}

const HEADING = { high: 'Best match', medium: 'Likely match', low: 'Possible match' } as const;

/** `found`: IntelliDealer knows the number the AI named. */
export function describeOutcome(query: string, id: HubPartIdentification, found: boolean): DescribeOutcome {
  const quoted = `“${query}”`;
  if (id.part_number && found) {
    const heading = `${HEADING[id.confidence] ?? HEADING.low} for ${quoted}`;
    return { kind: 'match', heading, note: id.confidence === 'high' ? null : 'Not 100% sure this is the one. Ask for a quote if in doubt.' };
  }
  // A number IntelliDealer does not carry is worth repeating only when the AI was fairly sure of it.
  if (id.part_number && id.confidence !== 'low') {
    const what = id.description ? `${id.part_number} (${id.description})` : id.part_number;
    return { kind: 'miss', heading: null, note: `We think you need part ${what}, but it isn't in our system. Ask for a quote and the parts desk will source it.` };
  }
  return { kind: 'miss', heading: null, note: `We couldn't pin down a part number for ${quoted}. Ask for a quote and the parts desk will find it.` };
}
